import { Reveal } from "@/components/site/Reveal";
import { useBooking } from "@/context/BookingContext";
import { IMAGES } from "@/data/content";
import { useContent } from "@/context/ContentContext";

export const Cafe = () => {
  const { openCafe } = useBooking();
  const { content } = useContent();
  const MENU = content.menu;

  return null ;
};
